export function calculatePriceDifference(originalPrice, sellPrice) {
  const difference = originalPrice - sellPrice;
  const differencePercentage = Math.round((difference * 100) / originalPrice);
  // 中文的折扣習慣使用「折扣後價格為原價的10分之幾」來表達，如 7 折，意思則為原價的 7/10
  const sellPriceRate = (sellPrice / originalPrice) * 10;

  return {
    difference,
    differencePercentage,
    sellPriceRate:
      Number.isInteger(sellPriceRate) || sellPriceRate < 1
        ? sellPriceRate
        : Math.round(sellPriceRate * 10),
  };
}



// WEBPACK FOOTER //
// ./app/utils/price.js